'use client';

import { BelugaAppLoader } from '@repo-ui/code-project/beluga-app';

export default function Page() {
  return <BelugaAppLoader />;
}
